import { render, staticRenderFns } from "./PolicyProposalsPage.vue?vue&type=template&id=015d7ce2&scoped=true"
import script from "./PolicyProposalsPage.vue?vue&type=script&lang=js"
export * from "./PolicyProposalsPage.vue?vue&type=script&lang=js"
import style0 from "./PolicyProposalsPage.vue?vue&type=style&index=0&id=015d7ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d7ce2",
  null
  
)

export default component.exports